export default __webpack_public_path__ + "static/media/Canach Battle Hood.20e00d4c.jpg";